import React, { useState, useEffect } from "react";
import usePlacesService from "react-google-autocomplete/lib/usePlacesAutocompleteService";
import { Box, List, ListItem, ListItemText, Typography, Paper } from "@mui/material";
import { useTheme, useMediaQuery } from "@mui/material";
interface AddressStepProps {
  initialAddress?: any; 
  onAddressSelect: (address: any) => void;
}

const AddressStep: React.FC<AddressStepProps> = ({ initialAddress, onAddressSelect }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [predictions, setPredictions] = useState(false);
  const [location, setLocation] = useState<any>(initialAddress || null); 

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (initialAddress) {
      setSearchQuery(initialAddress.description || "");
    }
  }, [initialAddress]);

  const {
    placePredictions,
    getPlacePredictions,
  } = usePlacesService({
    apiKey: "AIzaSyBzepvXcfi4uJL7LpF-aeKW8FVUdDxTonA",
  });

  const onPlaceChanged = (place: any) => {
    setLocation(place);
    setPredictions(false);
    onAddressSelect(place); // Pass selected address to parent
    console.log("Selected Place:", place);
  };

  const handleInputChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const value = evt.target.value;
    setSearchQuery(value);
    if (value.length > 0) {
      setPredictions(true);
      getPlacePredictions({ input: value });
    } else {
      setPredictions(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
        padding: 2,
        backgroundColor: "#ffffff",
        borderRadius: 2,
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        width: "100%",
        maxWidth: "800px",
        height: "500px",
        margin: "0 auto",
      }}
    >
      <Typography className="text-wrap text-sm" sx={{ color: "#333", textAlign: "center" }}>
        Enter the Address to continue!
      </Typography>
      <input
        type="text"
        placeholder="Search for your home address..."
        value={searchQuery}
        onChange={handleInputChange}
        style={{
          width: "100%",
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          fontSize: "16px",
          backgroundColor: "#f5f5f5",
        }}
      />
      {predictions && (
        <Paper
          elevation={3}
          sx={{
            width: "100%",
            maxHeight: isSmallScreen ? 300 : 200,
            overflowY: "auto",
            marginTop: 1,
            borderRadius: 1,
          }}
        >
          <List>
            {placePredictions.map((item, index) => (
              <ListItem
                button
                key={index}
                onClick={() => onPlaceChanged(item)}
                sx={{
                  "&:hover": {
                    backgroundColor: "#f0f0f0",
                  },
                }}
              >
                <ListItemText className="text-wrap" primary={item.description} />
              </ListItem>
            ))}
          </List>
        </Paper>
      )}
      {location && !predictions && (
        <Typography className="text-wrap" variant="body2" sx={{ color: "#555", marginTop: 2 }}>
          Selected Address: {location.description}
        </Typography>
      )}
    </Box>
  );
};

export default AddressStep;
